define(
({
  "load_error": "Lastfeil",
  "description": "En forespørsel ble ikke fullført riktig. Du bør sørge for at bestillingen din er lagret, og deretter oppdatere denne siden."
})
);
